import { render, staticRenderFns } from "./Summarize.vue?vue&type=template&id=815f6864&scoped=true"
import script from "./Summarize.vue?vue&type=script&lang=js"
export * from "./Summarize.vue?vue&type=script&lang=js"
import style0 from "./Summarize.vue?vue&type=style&index=0&id=815f6864&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815f6864",
  null
  
)

export default component.exports